import React from 'react';
import MentionUserTextEditor from "../addComment/mentionUser";
import MentionList from "./MentionList";
import EditorActions from "./EditorActions";

const CommentEditor = ({
  isMobile,
  comment,
  handleComment,
  handleMention,
  setElementPos,
  editorRef,
  mentionListVisible,
  anchorEl,
  elementPos,
  handleMentionClose,
  sortUser,
  handleChange,
  selectedUserForTag,
  handleUserSelect,
  handleSave,
  handleCancel,
  isDisable,
  containerId
}) => {
  return (
    <div
      className={isMobile ? "mobile-edit-comment-textEditor" : "edit-comment-textEditor"}
      id={containerId}>
      <MentionUserTextEditor
        value={comment}
        onChange={handleComment}
        onMention={handleMention}
        setEelementPros={setElementPos}
        ref={editorRef}
      />
      
      <MentionList
        mentionListVisible={mentionListVisible}
        anchorEl={anchorEl}
        elementPos={elementPos}
        handleMentionClose={handleMentionClose}
        sortUser={sortUser}
        handleChange={handleChange}
        selectedUserForTag={selectedUserForTag}
        handleUserSelect={handleUserSelect}
      />

      <EditorActions
        handleSave={handleSave}
        handleCancel={handleCancel}
        isDisable={isDisable}
        isMobile={isMobile}
      />
    </div>
  );
};

export default CommentEditor; 